module.exports = __webpack_public_path__ + "img/logo.3bda7891.svg";